// Conveniently import this file anywhere to use db
import firebase from './plugins/firebase'
import 'firebase/firestore'
import 'firebase/analytics'

firebase.firestore().settings({
  cacheSizeBytes: firebase.firestore.CACHE_SIZE_UNLIMITED,
  merge: true
})
// firebase.firestore().enablePersistence().catch((err) => console.log(err))
export const limitRefDB = 18
export const sliceNumberDB = 10
export const db = firebase.firestore()
export const postsDB = db.collection('posts')
export const notifDB = db.collection('notifications')
export const userDB = db.collection('users')
export const likesDB = db.collection('likes')
export const changesDB = db.collection('changes_list')
export const settingsDB = db.collection('Settings')

// Realtime
const realtimeDBRef = firebase.database()
export const realtimeDB = firebase.database()
export const DevicesCollection = realtimeDBRef.ref('/devices/')
export const EventsCollection = realtimeDBRef.ref('/events/')
// DevicesCollection.child().remove().then(function () {
//   console.log('Remove succeeded.')
// })
//   .catch(function (error) {
//     console.log('Remove failed: ' + error.message)
//   })
// EventsCollection.remove().then(function () {
//   console.log('Remove succeeded.')
// })
//   .catch(function (error) {
//     console.log('Remove failed: ' + error.message)
//   })
// realtimeDB.ref(`/devices/${DeviceInfo.getUniqueId()}`).set(DeviceInfoJson());
// const batch = firebase.firestore().batch();



// WEBPACK FOOTER //
// ./src/firestoreDB.js